import React, { useState, FunctionComponent } from 'react';
import { GetCustomizeCarModel_customizeCar_car_keyFeatures } from '../../../../../graphql/queries/__generated__/GetCustomizeCarModel';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import { Link, Collapse, useTheme } from '@material-ui/core';
import keyFeaturesStyles from './keyFeaturesStyles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { KeyFeature } from './KeyFeature';

interface ILimitedKeyFeaturesProps {
  keyFeatures: GetCustomizeCarModel_customizeCar_car_keyFeatures[];
}

const LimitedKeyFeatures: FunctionComponent<ILimitedKeyFeaturesProps> = ({ keyFeatures }) => {
  const [isFeaturesCollapsed, setFeaturesCollapsed] = useState(false);
  const styles = keyFeaturesStyles();
  const {
    spc: {
      customise: { maxVariantFeaturesToShow },
    },
  } = useTheme<ISpcTheme>();

  const DEFAULT_MAX_FEATURES_TO_SHOW = 4;
  const renderKeyFeature = (feature: GetCustomizeCarModel_customizeCar_car_keyFeatures) => (
    <KeyFeature key={feature.id} shortname={feature.shortname} disclaimer={feature.attributes?.disclaimer} />
  );

  return (
    <>
      {keyFeatures.map(
        (feature: GetCustomizeCarModel_customizeCar_car_keyFeatures, index: number) =>
          index < (maxVariantFeaturesToShow || DEFAULT_MAX_FEATURES_TO_SHOW) && renderKeyFeature(feature),
      )}
      {keyFeatures.length > (maxVariantFeaturesToShow || DEFAULT_MAX_FEATURES_TO_SHOW) && (
        <>
          <Collapse in={isFeaturesCollapsed}>
            {keyFeatures
              .slice(maxVariantFeaturesToShow || DEFAULT_MAX_FEATURES_TO_SHOW)
              .map((feature: GetCustomizeCarModel_customizeCar_car_keyFeatures) => renderKeyFeature(feature))}
          </Collapse>
          <Link
            onClick={() => setFeaturesCollapsed(!isFeaturesCollapsed)}
            variant="caption"
            data-test={`customise:showMoreFeaturesLink:${isFeaturesCollapsed}`}
            className={styles.showHideLink}
          >
            {
              <Translation
                id={
                  isFeaturesCollapsed
                    ? `trans__configurator__variants_page__hide_features_link`
                    : 'trans__configurator__variants_page__showMore_features_link'
                }
              />
            }
          </Link>
        </>
      )}
    </>
  );
};

export default LimitedKeyFeatures;
